import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Dienst} from '../../../dienst/dienst';
import {ClientDienst} from '../../client-dienst';
import {TaakType} from '../../../dienst/taak';
import {Zone} from "../../../zone/zone";

@Component({
    selector: 'zah-client-dienst',
    templateUrl: './client-dienst.component.html',
    styleUrls: ['./client-dienst.component.scss'],
    standalone: false
})
export class ClientDienstComponent implements OnInit {

  @Input()
  zones: Zone[];
  @Input()
  clientDienst: ClientDienst;
  @Input()
  dienst: Dienst;
  @Input()
  expanded = false;
  @Output()
  deleteClicked: EventEmitter<ClientDienst> = new EventEmitter<ClientDienst>();

  taakTypes: Array<TaakType> = [];
  dienstFilteredOnTaakType: { TaakType?: Dienst } = {};

  ngOnInit(): void {
    this.taakTypes = this.dienst.getTaakTypes();
    this.taakTypes.forEach(taakType => this.dienstFilteredOnTaakType[taakType] = this.dienst.filterOnTaakType(taakType));
  }

  onDeleteClick(): void {
    this.deleteClicked.emit(this.clientDienst);
  }

  onZoneChanged(zoneId: string) {
    this.clientDienst.setZoneId(zoneId);
  }
}
